import { Component } from '@angular/core';
import { MessageService } from 'src/app/services/message.service';

import { AuthService } from 'src/app/shared/auth.service';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.css']
})
export class LogoutComponent {
  
    constructor(public authService: AuthService,
      private messageService: MessageService) {
      messageService.disconnect()
      authService.logout()
    }
}
